import { AdminManagedBadge } from '@calendly/ui/components/admin-managed-badge';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconTrash } from '@calendly/ui/components/glyphs/IconTrash';
import { IconButton } from '@calendly/ui/components/icon-button';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconActive } from '@calendly/ui/theme';
const cardCss = "c5sc1t7";
const iconBoxCss = "i1vnsfuq";
const contentCss = "ct4n3do";
const titleCss = "thv99sb";
const subtitleCss = "s1ekoqex";
const mainRegionCss = "m1qhriad";
const actionsCss = "anernsu";
const actionSlotCss = "axokytf";

// Presentational card for the CRUD automations list. Mirrors NotificationCard layout
// but opens the workflow on click and exposes a trailing remove action.
export const AutomationCard = ({
  icon,
  title,
  subtitle,
  onOpen,
  onRemove,
  showAdminManagedBadge = false,
  removeLabel,
  'data-testid': dataTestId
}) => {
  const mainContent = <>
      {icon ? <div className={iconBoxCss} aria-hidden="true">
          <UiIcon icon={icon} size="medium" title="" color={colorIconActive} />
        </div> : null}
      <div className={contentCss}>
        <LabelText size="large" className={titleCss}>
          {title}
        </LabelText>
        {subtitle ? <BodyText color="muted" size="small" className={subtitleCss}>
            {subtitle}
          </BodyText> : null}
      </div>
    </>;
  return <div className={cardCss} data-testid={dataTestId}>
      {onOpen ? <BareButton type="button" className={mainRegionCss} onClick={onOpen}>
          {mainContent}
        </BareButton> : <div className={mainRegionCss}>
          {mainContent}
        </div>}
      <div className={actionsCss}>
        {showAdminManagedBadge ? <div className={actionSlotCss}>
            <AdminManagedBadge iconOnly text="Admin managed" />
          </div> : null}
        {onRemove ? <div className={actionSlotCss}>
            <IconButton appearance="ghost" size="small" icon={IconTrash} onClick={onRemove} title={removeLabel} aria-label={removeLabel} />
          </div> : null}
      </div>
    </div>;
};

require("./automation_card.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./automation_card.js");